export default {
  getTotalMembershipPaid (payments) {
    if (!payments) {
      return 0
    }
    let paymentSum = 0
    payments.forEach((data) => {
      paymentSum += parseInt(data.payment_amount)
    })
    return paymentSum
  },
  getPaymentType (payment) {
    if (payment.no_of_installments === 1) {
      return 'One-time'
    }
    if (payment.no_of_installments > 1) {
      return 'Instalment'
    }
    // if (payment.package_type === 1) {
    if (payment.package_type === 'Monthly') {
      return 'Monthly'
    }
    // if (payment.membership_period_id === 2 || payment.membership_period_id === 3 || payment.membership_period_id === 4) {
    if (payment.package_type === 'Annually') {
      return 'Annual'
    }
    /*
    if(payment.membership_recurring_status === 'not_required') {
      return 'N/A'
    }
    */
    return 'N/A'
  },
  isActiveMembership (id, payments) {
    if (!payments || (Array.isArray(payments) && payments.length === 0)) {
      return false
    }
    if (payments[0].membership_id === id) {
      return true
    }
    return false
  },
  getTotalPaid (payments) {
    if (!payments || (Array.isArray(payments) && payments.length === 0)) {
      return 0
    }
    let paymentSum = 0
    payments.forEach((payment) => {
      paymentSum += payment.payment_amount
    })
    return paymentSum
  },
  getTotalRefundAmount (payments) {
    if (!payments || (Array.isArray(payments) && payments.length === 0)) {
      return 0
    }
    let paymentSum = 0
    payments.forEach((payment) => {
      payment.refund_payments.forEach((rePayment) => {
        paymentSum += rePayment.refunded_amount
      })
    })
    return paymentSum
  },
  getPaymentsRemain (membershipPeriodId, noOfInstallments, payments) {
    if (membershipPeriodId !== 5) {
      return 0
    }
    return noOfInstallments - payments.length
  },
  getLastPaymentDate (payments) {
    if (!payments || (Array.isArray(payments) && payments.length === 0)) {
      return false
    }
    return payments[payments.length - 1].created_at
  },
  getFirstPaymentDate (payments) {
    if (!payments || (Array.isArray(payments) && payments.length === 0)) {
      return false
    }
    return payments[0].created_at
  },
  isRefunded (payments) {
    if (!payments || (Array.isArray(payments) && payments.length === 0)) {
      return false
    }
    return payments[payments.length - 1].payment_status === 2
  },
  lastPaymentStatus (payments) {
    if (!payments || (Array.isArray(payments) && payments.length === 0)) {
      return false
    }
    return payments[payments.length - 1].payment_status
  }
}



// WEBPACK FOOTER //
// ./src/helper/membership.js